import fetch, { Blob, Headers, RequestInit } from 'node-fetch';
import PixagriScopes from '../../core/models/PixagriScopes';
import { BaseWagoNestApiService } from '../../core/services/apiServices/BaseWagoNestApiService';
import ProcessingType from '../../processing/models/ProcessingType';
import { FieldStatisticRecord } from '../models/FieldStatisticRecord';
import StatisticIndicatorType from '../models/StatisticIndicatorType';

class WagoStatisticsApiService extends BaseWagoNestApiService {
    FIELD_PARAM_KEY = 'fieldRef';
    FIELD_PARAM = `:${this.FIELD_PARAM_KEY}`;
    PROCESSING_PARAM_KEY = 'processingType';
    PROCESSING_PARAM = `:${this.PROCESSING_PARAM_KEY}`;
    INDICATOR_PARAM_KEY = 'indicatorType';
    INDICATOR_PARAM = `:${this.INDICATOR_PARAM_KEY}`;
    CAMPAIGN_PARAM_KEY = 'campaignId';
    CAMPAIGN_PARAM = `:${this.CAMPAIGN_PARAM_KEY}`;

    getStatisticEnpoint() {
        return `/${PixagriScopes.CAMPAIGN}/${this.CAMPAIGN_PARAM}/${PixagriScopes.FIELDS}/${this.FIELD_PARAM}/${PixagriScopes.PROCESSINGS}/${this.PROCESSING_PARAM}/${PixagriScopes.INDICATORS}/${this.INDICATOR_PARAM}`   
     }
        getStatisticsUrl(
        campaignId: string,
        fieldRef: string,
        processingType: ProcessingType,
        indicatorType: StatisticIndicatorType,
    ) {

        return `${this.getBaseUrl()}/${PixagriScopes.STATISTICS}${this.getStatisticEnpoint().replace(
            this.CAMPAIGN_PARAM,
            campaignId,
        )
            .replace(this.FIELD_PARAM, fieldRef)
            .replace(this.PROCESSING_PARAM, processingType)
            .replace(this.INDICATOR_PARAM, indicatorType)}`;
    }
      
    async getStatistics(
        token: string,
        campaignId: string,
        fieldRef: string,
        processingType: ProcessingType,
        indicator: StatisticIndicatorType,
    ): Promise<FieldStatisticRecord[]> {
        const url = this.getStatisticsUrl(
            campaignId,
            fieldRef,
            processingType,
            indicator,
        );
        const res = await this.sendRequest<FieldStatisticRecord[]>(
            token,
            url,
            'GET',
        );
        if (res.error) {
            throw res.error_message;
        }
        return res.response;
    }

  async exportResumeData(
    token: string,
    campaing_id: number,
    service: string,
  ): Promise<Blob> {
    const url = `${this.getBaseUrl()}/statistics/campaign/${campaing_id}/export`;
    const header = new Headers();
    header.append('Authorization', `Bearer ${token}`);
    header.append('Accept', 'text/csv');
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: header,
      redirect: 'follow',
    };

    const response = await fetch(url, requestOptions);
    if (response && response.status > 300) {
      throw new Error(
        `Error while exporting account data code: ${response.status}`,
      );
    }
    const blob = await response.blob();
    return blob;
  }
}

const wagoStatisticsApiService = new WagoStatisticsApiService();
export default wagoStatisticsApiService;
